import React from "react";
import { getBrandLogoUrl, getBrandFallback } from "../utils/brandLogo";

export default function BrandLogo({
  label,
  variant = "noText",
  className = "",           // extra classes for <img>
  mode = "chip",
  boxClass = "",            // controls wrapper sizing (e.g., "w-[160px] h-[72px]")
  alt = "brand-logo",
  boxJustify = "center",
}) {
  const src = getBrandLogoUrl(label, variant);
  const fallback = getBrandFallback(variant);

  const wrapperBase =
    mode === "chip"
      ? "shrink-0 rounded-lg bg-white/90 ring-1 ring-slate-200/50 p-1 md:p-2"
      : mode === "glow"
      ? "md:shrink-0 shrink min-w-0 overflow-hidden filter drop-shadow-[0_0_6px_rgba(255,255,255,0.35)]"
      : mode === "blend"
      ? "md:shrink-0 shrink min-w-0 overflow-hidden mix-blend-screen"
      : ""; // plain

  const justifyCls = boxJustify === 'end' ? 'justify-end' : boxJustify === 'start' ? 'justify-start' : 'justify-center';

  const baseImgClass =
    mode === "chip"
      ? "max-h-full max-w-full object-contain"
      : "h-auto w-auto max-h-10 max-w-[120px] md:max-h-12 md:max-w-[160px] object-contain";

  const imgEl = (
    <img
      src={src}
      alt={alt}
      className={`${baseImgClass} ${className}`}
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = fallback;
      }}
    />
  );

  // Wrap when either a wrapper style is requested (chip/glow/blend) OR a size is provided
  if (wrapperBase || boxClass) {
    return (
      <div className={`${wrapperBase} ${boxClass} flex items-center ${justifyCls}`}>
        {imgEl}
      </div>
    );
  }

  // Otherwise return plain image
  return imgEl;
}
